exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* purgecss start ignore */\n.v-dropdown-menu__container {\n  min-width: 300px !important;\n  max-height: 300px !important;\n  overflow: auto !important;\n}\n\n/* purgecss end ignore */\n\n", ""]);

// exports
